import axios from 'axios';
import { getPageName } from '../utils/pageName';
import { Domain, Juridiction, Ville } from '../entity/entity.types';

interface CustomWindow extends Window {
  /* eslint-disable camelcase */
  read_key: string;
  /* eslint-enable camelcase */
}

declare let window: CustomWindow;

const getAccessKey = () => {
  const pageName = getPageName();
  const readKey = pageName === 'Search' ? 'SEARCH' : window.read_key;
  return readKey;
};

export async function fetchLawyerDecisions(
  lawyerId: string,
): Promise<{
  domains: Domain[];
  decisionCount: number;
  juridictions: Juridiction[];
  villes: Ville[];
}> {
  const readKey = getAccessKey();
  return (
    await axios.get('/getLawyerDecisions', {
      params: {
        lawyerId,
        readKey,
      },
    })
  ).data;
}

export async function fetchLawyerKeywords(
  lawyerId: string,
): Promise<{ array: string[] }> {
  const readKey = getAccessKey();
  return (
    await axios.get('/professional_ajax/getKeywords', {
      params: {
        lawyerId,
        readKey,
      },
    })
  ).data;
}

export function fetchEnterprises(lawyerId: string, full: boolean = false) {
  const readKey = getAccessKey();
  return axios.get('/getLawyerEnterprises', {
    params: {
      lawyerId,
      readKey,
      full,
    },
  });
}

export async function fetchLawyerCustomers(lawyerId: string) {
  const readKey = getAccessKey();
  return (
    await axios.get('/getLawyerCustomers', {
      params: {
        lawyerId,
        readKey,
      },
    })
  ).data;
}

export function fetchDecisions(lawyerId: string) {
  const readKey = getAccessKey();
  return axios.get('/getLawyerTopDecisions', {
    params: {
      lawyerId,
      readKey,
    },
  });
}

export function showEmailOnClick(lawyerId: string) {
  return axios.get('/getContactEmail', {
    params: {
      lawyerId,
    },
  });
}

export function fetchCommentaries(
  lawyerId: string,
  full: boolean,
  userGeneratedOnly: boolean,
) {
  return axios.get('/professional_ajax/getCommentaries', {
    params: {
      lawyerId,
      full,
      userGeneratedOnly,
    },
  });
}

export function fetchLawyerInfos(lawyerId: string) {
  return axios.get('/getLawyerPopover', {
    params: {
      lawyerId,
    },
  });
}

export async function fetchProfessionalInfos() {
  return (await axios.get('/getProfessionalInfos')).data;
}

export async function setWantToBeContacted(lawyerId: string) {
  return (await axios.post('/wantToBeContacted', { lawyerId })).data;
}
